import { FC } from 'react'
import { Box, Typography, Paper } from '@mui/material'
import { Settings as SettingsIcon } from '@mui/icons-material'

export const Settings: FC = () => {
  return (
    <Box>
      <Paper
        elevation={2}
        sx={{
          padding: 4,
          textAlign: 'center',
          minHeight: 300,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SettingsIcon sx={{ fontSize: 64, color: 'text.secondary', marginBottom: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Settings
        </Typography>
        <Typography color="text.secondary">
          Settings page is currently empty. Configuration options will be added here.
        </Typography>
      </Paper>
    </Box>
  )
}
